import React from 'react';
import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';

export const JoinBeta = () => {
  return (
    <>
      <Row justify='center' style={{ margin: '40px auto' }}>
        <Col
          xl={20}
          style={{
            background: '#8053D7',
            borderRadius: 6,
            filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
            padding: 40
          }}
        >
          <p
            style={{
              fontSize: '2.5em',
              fontFamily: 'Montserrat Bold',
              color: '#fff',
              textAlign: 'center'
            }}
          >
            <FormattedMessage id='join-beta.title' />
            <a href='https://www.tampabay.com/news/education/2021/02/03/90000-florida-kids-didnt-show-up-for-school-this-year-where-are-they/' target='_blank' rel='noreferrer'>
              <span style={{ color: '#FFDC54' }}><FormattedMessage id='join-beta.statistic-link' /></span>
            </a>
          </p>
          <p style={{ color: '#fff', textAlign: 'center' }}>
            <FormattedMessage id='join-beta.description' />
          </p>
        </Col>
      </Row>
    </>
  );
};
